import React from "react";
import classes from "./LeftSection.module.css";

import coverImg3 from "../../Assets/mmt.png";
import formIcon1 from "../../Assets/form-icon1.png";
import formIcon2 from "../../Assets/form-icon2.png";
import logo from "../../Assets/MMT_Green_White.png";

export default function LeftSection() {
  return (
    <div className={`relative text-white ${classes.coverLeft}`}>
      <img src={coverImg3} alt="Cover" className={`w-full ${classes.coverImage}`} />
      
      <div className={`px-6 md:px-12 lg:px-28 ${classes.formLeftBox}`}>
        
        {/* Logo */}
        <div className={classes.logoContainer}>
          <img src={logo} alt="Logo" className={classes.logoImage} />
      
        </div>

        {/* Tagline */}
        <p className={`${classes.taglineText} mb-14 text-center`}>
          MakeMyTools provides you a platform to create custom tool requirements and get a quote from valid suppliers.
        </p>

        {/* List of Features */}
        <ul className={classes.featuresList}>
          <li className={classes.featureItem}>
            <span>
              <img src={formIcon1} className={classes.icon} alt="Icon 1" />
            </span>
            <div>Create your own custom tool requirement</div>
          </li>
          <li className={classes.featureItem}>
            <span>
              <img src={formIcon2} className={classes.icon} alt="Icon 2" />
            </span>
            <div>Get quotes from verified suppliers</div>
          </li>
          <li className={classes.featureItem}>
            <span>
              <img src={formIcon1} className={classes.icon} alt="Icon 3" />
            </span>
            <div>Connect with verified buyers and increase your business</div>
          </li>
        </ul>
      </div>
    </div>
  );
}
